import React from "react";
import { Checkbox, FormControlLabel } from "material-ui";
import { WrappedFieldProps } from "redux-form";
import LensIcon from "material-ui-icons/Lens";
import { Common } from "./Common";

const renderCheckBoxWithLabel = (props: Common & WrappedFieldProps) => {
    const { input, meta, style, label, required, ...nonprops } = props;

    let t = style || {};

    const styles = {
        ...t,
    };

    const errorClass = meta.touched && meta.error ? " error" : "";
    const cbError = meta.touched && meta.error ? "cb-error" : "";

    const labelElem = required ? (
        <span>
            {label}
            <LensIcon className={"hypo-lens-icon" + errorClass} />
        </span>
    ) : (
        label
    );

    return (
        <FormControlLabel
            classes={{ label: "cb-label" }}
            control={
                <Checkbox
                    {...nonprops}
                    {...input}
                    checked={!!input.value}
                    value={input.value.toString()}
                    style={styles}
                    className={cbError}
                />
            }
            label={labelElem}
        />
    );
};

export default renderCheckBoxWithLabel;



// WEBPACK FOOTER //
// ./src/components/form/RenderCheckBoxWithLabel.tsx